// @ts-check
import {
  Box,
  SkeletonBox,
  SkeletonText,
  TabbedMenu,
  TabbedMenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '~/design-system';

/**
 * The props that this component needs.
 * @typedef {object} MatchSuppliersStepProps
 * @property {string} importId
 * @property {string} tab
 */

/**
 * Renders the suppliers page overview, with the list of matched and unmatched suppliers
 * @returns
 */
export default function SuppliersOverviewSkeleton({ ...rest }) {
  return (
    <Box {...rest}>
      <TabbedMenu sx={{ margin: 0 }}>
        <TabbedMenuItem>
          <SkeletonText width={100} />
        </TabbedMenuItem>
        <TabbedMenuItem>
          <SkeletonText width={100} />
        </TabbedMenuItem>
        <TabbedMenuItem>
          <SkeletonText width={100} />
        </TabbedMenuItem>
      </TabbedMenu>

      <Table>
        <TableHead>
          <TableRow>
            <TableHeader
              sx={{ backgroundColor: 'brand.lightGray', width: 160 }}
            />
            <TableHeader
              sx={{ backgroundColor: 'brand.lightGray', width: 220 }}
            >
              <SkeletonText width={100} />
            </TableHeader>
            <TableHeader
              sx={{ backgroundColor: 'brand.lightGray', width: 220 }}
            >
              <SkeletonText width={100} />
            </TableHeader>
            <TableHeader
              sx={{ backgroundColor: 'brand.lightGray', width: 100 }}
            />
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRowSkeleton />
          <TableRowSkeleton />
          <TableRowSkeleton />
        </TableBody>
      </Table>
    </Box>
  );
}

function TableRowSkeleton() {
  return (
    <TableRow>
      <TableCell sx={{ paddingLeft: '20px', paddingRight: '20px' }}>
        <SkeletonBox width={80} height={80} />
      </TableCell>
      <TableCell>
        <SkeletonText width={100} />
      </TableCell>
      <TableCell>
        <SkeletonText width={100} />
      </TableCell>
      <TableCell>
        <SkeletonText width={100} />
      </TableCell>
    </TableRow>
  );
}
